import { render, staticRenderFns } from "./VerticalScrollIcon.vue?vue&type=template&id=55bc72a5&"
import script from "./VerticalScrollIcon.vue?vue&type=script&lang=js&"
export * from "./VerticalScrollIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports